<template>
  <div
    class="relative mt-10 bg-gradient-to-l md:bg-gradient-to-b to-[#E72B6F] from-[#1450A0] md:from-[#E72B6F] md:to-[#1450A0] bg-cover bg-center bg-no-repeat w-full h-auto overflow-hidden"
  >
    <nuxt-img
      src="images/benefits/estrella.png"
      class="absolute w-40 lg:w-52 xl:w-80 -top-[5%] lg:top-[-12%] xl:-top-[16%] md:rotate-45 right-5 md:right-10 opacity-30"
    />
    <nuxt-img
      src="images/benefits/corazon.png"
      class="absolute w-40 lg:w-48 xl:w-80 -bottom-[5%] lg:bottom-[-12%] xl:-bottom-[16%] md:rotate-45 left-5 md:left-10 opacity-30"
    />

    <div class="container relative px-5 my-10 lg:my-20">
      <h1
        class="flex items-center justify-center w-full px-10 pt-10 pb-16 text-lg font-extrabold leading-6 text-center text-white top-10 lg:text-3xl lg:leading-9"
      >
       {{ t('cardGeneralInfo.title') }}
      </h1>
      <div
        class="grid justify-items-center xl:place-items-stretch lg:grid-cols-2 xl:grid-cols-3 bg-transparent lg:gap-x-[27px] lg:gap-y-6 lg:py-12"
      >
        <template v-for="(item, i) in benefits" :key="item">
          <HomepageBenefitCard
            :title="item.title"
            :description="item.description"
            :imageSrc="item.icon"
            :type="item.type"
            :class="[i !== 0 ? 'my-[34px] lg:my-6' : 'mb-[34px] lg:my-6']"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const benefits = [
  {
    icon: "/images/benefits/exclusive-discount.png",
    type: t("cardGeneralInfo.features.featureOne.type"),
    title: t("cardGeneralInfo.features.featureOne.title"),
    description: t("cardGeneralInfo.features.featureOne.description"),
  },
  {
    icon: "/images/benefits/pastel.png",
    type: t("cardGeneralInfo.features.featureTwo.type"),
    title: t("cardGeneralInfo.features.featureTwo.title"),
    description: t("cardGeneralInfo.features.featureTwo.description"),
  },
  {
    icon: "/images/benefits/cumpleanos.png",
    type: t("cardGeneralInfo.features.featureThree.type"),
    title: t("cardGeneralInfo.features.featureThree.title"),
    description: t("cardGeneralInfo.features.featureThree.description"),
  },
  {
    icon: "/images/benefits/bomba.png",
    type: t("cardGeneralInfo.features.featureFour.type"),
    title: t("cardGeneralInfo.features.featureFour.title"),
    description: t("cardGeneralInfo.features.featureFour.description"),
  },
  {
    icon: "/images/benefits/bag.png",
    type: t("cardGeneralInfo.features.featureFive.type"),
    title: t("cardGeneralInfo.features.featureFive.title"),
    description: t("cardGeneralInfo.features.featureFive.description"),
  },
  {
    icon: "/images/benefits/bag-star.png",
    type: t("cardGeneralInfo.features.featureSix.type"),
    title: t("cardGeneralInfo.features.featureSix.title"),
    description: t("cardGeneralInfo.features.featureSix.description"),
  },
];

defineProps({
  designClasses: {
    type: String,
    default: "mt-[105px]",
  },
});
</script>
